import { LOGOS } from "@/data/site";

// Real institutional logos (extracted from the official VAANI brochure),
// presented on clean light chips so they stay legible over both the dark
// hero and the light scrolled navbar.
const chip =
  "flex h-16 items-center justify-center rounded-md bg-white px-1.5 shadow-[0_1px_3px_hsl(218_40%_20%_/_0.18)] ring-1 ring-black/5";

export const BrandLockup = () => (
  <div className="flex items-center gap-2">
    <div className={chip}>
      <img
        src={LOGOS.iem}
        alt="Institute of Engineering & Management logo"
        className="h-16 w-auto object-contain"
      />
    </div>
    <div className={chip}>
      <img
        src={LOGOS.uem}
        alt="University of Engineering & Management logo"
        className="h-16 w-auto object-contain"
      />
    </div>
    <div className={`${chip} hidden sm:flex`}>
      <img
        src={LOGOS.aicte}
        alt="AICTE logo"
        className="h-16 w-auto object-contain"
      />
    </div>
  </div>
);
